module.exports = __webpack_public_path__ + "static/grass-sunset-video-f71daae7efc0483f38152ac72a315bc8.mp4";